import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import tdmRatings from "../../../../src/data/articles/cube-prospective-tarkir-dragonstorm/tdm-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  tdmRatings,
  ProspectiveIntro,
  React
};